import {ApiClient} from "../utils/apiClient";
import {setAlert} from "./alert";
import {AlertTypes} from "@leap4/frontend";

export const createNewObject = async (object: any, url: string) => {
    try {
        const res = await ApiClient.post(url, object);
        return res.data;
    } catch (err) {
        console.log("error on create new object")
        setAlert("Couldn't fetch object", AlertTypes.FAILURE);
    }
}

export const updateObjectById = async (id, object: any, url: string) => {
    try {
        const response = await ApiClient.patch(`${url}/${id}`,object);
        console.log(response)
    } catch (err) {
        console.log("error on update new object")
        setAlert("Couldn't fetch object", AlertTypes.FAILURE);
    }
}

